import {BaseCriteriaModel} from '../../base-criteria.model';
import {Optional} from 'typescript-optional';

export class WfIssueLabelCriteriaClass extends BaseCriteriaModel {
  guid?: Optional<string> = Optional.empty();
  guid_parent?: Optional<string> = Optional.empty();
  level_value?: Optional<string> = Optional.empty();
  txn_type?: Optional<string> = Optional.empty();
  code?: Optional<string> = Optional.empty();
  name?: Optional<string> = Optional.empty();
  descr?: Optional<string> = Optional.empty();
  label_type?: Optional<string> = Optional.empty();
  label_list_guid?: Optional<string> = Optional.empty();
  param_code?: Optional<string> = Optional.empty();
  param_name?: Optional<string> = Optional.empty();
  param_type?: Optional<string> = Optional.empty();
  value_string?: Optional<string> = Optional.empty();

  guids?: Optional<string> = Optional.empty(); /** @param guids is comma separated E.g: 4BC80017-22CC-4A29-9511-E22C4EB97AD5,4BC80017-22CC-4A29-9511-E22C4EB97AD5*/
}

export class WfIssueLabelCriteriaModel {
  query = '';

  constructor(criteria: WfIssueLabelCriteriaClass) {

    if (!criteria) {
      return;
    }

    // this.query += LabelQueryCriteriaClass.convertOptionalStringToQueryParms(labelCriteriaModel.guid_parent, 'guid_parent' );
    this.query += criteria.guid.filter(x => x !== '').map(x => '&guid=' + x).orElse('');
    this.query += criteria.guid_parent.filter(x => x !== '').map(x => '&guid_parent=' + x).orElse('');
    this.query += criteria.level_value.filter(x => x !== '').map(x => '&level_value=' + x).orElse('');
    this.query += criteria.txn_type.filter(x => x !== '').map(x => '&txn_type=' + x).orElse('');
    this.query += criteria.code.filter(x => x !== '').map(x => '&code=' + x).orElse('');
    this.query += criteria.name.filter(x => x !== '').map(x => '&name=' + x).orElse('');
    this.query += criteria.descr.filter(x => x !== '').map(x => '&descr=' + x).orElse('');
    this.query += criteria.label_type.filter(x => x !== '').map(x => '&label_type=' + x).orElse('');
    this.query += criteria.label_list_guid.filter(x => x !== '').map(x => '&label_list_guid=' + x).orElse('');
    this.query += criteria.param_code.filter(x => x !== '').map(x => '&param_code=' + x).orElse('');
    this.query += criteria.param_name.filter(x => x !== '').map(x => '&param_name=' + x).orElse('');
    this.query += criteria.param_type.filter(x => x !== '').map(x => '&param_type=' + x).orElse('');
    this.query += criteria.value_string.filter(x => x !== '').map(x => '&value_string=' + x).orElse('');
    this.query += criteria.guids.filter(x => x !== '').map(x => '&guids=' + x).orElse('');


    this.query += '&status=' + criteria.status;
    // this.query += '&orderBy=' + labelCriteriaModel.orderBy;
    this.query += '&order=' + criteria.order;
    this.query += '&offset=' + criteria.offset;
    this.query += '&limit=' + criteria.limit;
  }
}
